<template>
  <div class="uniTrenr" style="width:100%; ">
    <div class="bg-image" style="position: relative;">
      <img class="bgImg" src="../../assets/read/banner2x.png" alt="">
      <div class="ciscset">
        <div class="between">
          <div 
          v-for="(item,indexCla) in lsitData" 
          :key="indexCla"
          :class="[classIndex === indexCla ? 'itemActive' : 'item']">
            <div class="container" >
                <div class="image-wrap">
                  <img :src="item.img" alt="Your Image">
                </div>
                <div class="info-wrap">
                  <div class="name">{{item.name}}</div>
                  <div class="gender"></div>
                </div>
            </div>
          </div>
       
        </div>
      </div>
    </div>
    <div class="flex-container">
      <div class="left">
          <ul class="ulr">
              <li v-for="(item,sent) in img" :key="sent" :class="[activeName === sent ? 'purple-active' : 'bg-purple']" 
                  @click="switchStyle(sent)">
                  <i :class="item.icon"></i> {{item.name}}
              </li>
          </ul>
      </div>
      <div class="right">
        <div class="top-seir" v-if="activeName=== 0 && ChapterDisplay">
          <div
            :class="[typeOf === index ? 'boxvice' : 'containerImage']"
            v-for="(item, index) in classification"
            :key="index"
            @click="switchButton(index, item)"
          >
              <img class="Imaset" :src="item.picturePath" alt="" />  
              <p>{{ item.categoryName }}</p>
          </div>
        </div>
        <div class="offown" v-if="activeName=== 0">
          <div v-if="ChapterDisplay && article.length > 0">
             <div
               :class="[stateOf === inds ? 'conertcive' : 'conert']"
               v-for="(ite, inds) in article"
               :key="inds"
               @click="clickToSwitch(ite,inds)"
             >
               <el-row :gutter="20">
                 <el-col :span="16">
                   <div class="container">
                     <img :src="ite.picturePath" alt="" />
                     <div class="text-container">
                       <p>{{ ite.bookName }}</p>
                       <p style="font-size: 15px">作者：{{ ite.author }}</p>
                       <p style="font-size: 15px; color: #464645;">
                         {{ ite.introduce}}
                       </p>
                     </div>
                   </div>
                 </el-col>
                 <el-col :span="4">
                   <div class="container">
                     <div
                       class="text-container"
                       style=" text-align: center; display: flex;align-items: center;justify-content: center;" >
                       <p>故事</p>
                     </div>
                   </div>
                 </el-col>
                 <el-col :span="4">
                   <div class="container">
                     <div
                       class="text-container"
                       style="display: flex; align-items: center;justify-content: right;" >
                       <i
                         class="el-icon-arrow-right"
                         style="margin-left: 30px"
                       ></i>
                     </div>
                   </div>
                 </el-col>
               </el-row>
             </div>
          </div>
       <!-- 章节 -->
          <div v-if="!ChapterDisplay">
             <i class="el-icon-arrow-left" @click="Backrent">{{bookName}}</i>
             <div 
               class="lisrCare"
               v-for="(iem,indexA) in chapter"
               :key="indexA"
               @click="clickEvent(iem,indexA)"
               >
                 <span>{{iem.chapterName}}</span>
                 <div class="stateTyoe">
                       <el-tag v-if="iem.state == 'true' ">已读</el-tag>
                 </div>
                 <div class="read">
                    <el-button type="primary" v-if="(type == indexA) && isShow" @click="readChapter(iem)">开始阅读</el-button>
                 </div>
                 <!-- <span class="blue" v-if="type == indexA">✿</span> -->
             </div>
          </div>
          <div v-if="article.length == 0">
            <el-empty :image-size="200"></el-empty>    
          </div>
        </div>
        <div class="popup" v-if="activeName=== 1">
          <el-row>
              <el-col :span="12">
                  <div class="bg-pur-light proup">
                      <img src="../../assets/home/ranking.png" alt=""/>
                      阅读排行榜
                  </div>
              </el-col>
              <el-col :span="12">
                  <div class="bg-pur-light proup1" @click="geartek(tielec)">
                      <img src="../../assets/home/hengzhi.png" alt=""/>
                      {{tielec}}
                  </div>
              </el-col>
          </el-row>
          <table style="width: 100%; border-spacing: 0px;border-collapse: collapse; ">
               <tr  style="border: none;background-color: #E5F6FF;">
                  <td style="width: 10%;text-align:center;">  {{ myRank }}</td>
                  <td style="width: 15%;text-align:left;padding-left: 20px;"> 
                    <img :src="ownData.headImg ? male[ownData.headImg].img : male[0].img" alt=""/>  {{ownData.memberName}}
                  </td>
                  <td style="width: 55%;text-align:center;color:#1F9CFB;">{{ownData.chapterQuantity}}</td>
                  <td style="width: 20%;text-align:center;color:#1F9CFB;">{{ownData.numberOfAnswers}}</td>
               </tr>
          </table>
           <table style="width: 100%;border-spacing: 0px;border-collapse: collapse;background-color: #f5f9ff;">
              <thead>
              <tr style="border: none;">
                  <th style="width: 10%;">排名</th>
                  <th style="width: 15%;">姓名</th>
                  <th style="width: 55%;">阅读文章数</th></th>
                  <th style="width: 20%;">答题数</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(person,indexse) in people" :key="person.id" style="border: none;">
                  <td style="width: 10%;text-align:center;"> 
                    <img v-if="indexse===0" src="../../assets/badge1.png" alt="">
                    <img v-else-if="indexse===1" src="../../assets/badge2.png" alt="">
                    <img v-else-if="indexse===2" src="../../assets/badge3.png" alt="">
                    <span v-else>{{indexse+1}}</span> 
                  </td>
                  <td style="width: 15%;text-align:left;padding-left: 20px;"> 
                      <img :src="person.headImg ? male[person.headImg].img : male[0].img" alt=""/>  {{person.memberName}}
                  </td>
                  <td style="width: 55%;text-align:center;">{{person.chapterQuantity}}</td>
                  <td style="width: 20%;text-align:center;">{{ person.numberOfAnswers}}</td>
              </tr>
              </tbody>
          </table>
        </div>
        <div v-if="activeName=== 2">
          <div class="offown">
            <div v-if="ChapterDisplay && Hidesead.length > 0">
               <div
                 class="conert"
                 v-for="(item, sedIndex) in Hidesead"
                 :key="sedIndex"
               >
                 <el-row :gutter="20">
                   <el-col :span="16">
                     <div class="container">
                       <img :src="item.picturePath" alt="" />
                       <div class="text-container">
                         <p>{{ item.bookName }}</p>
                         <p style="font-size: 15px">{{ item.chapterName }}</p>
                       </div>
                     </div>
                   </el-col>
                   <el-col :span="4">
                     <div class="container">
                       <div
                         class="text-container"
                         style=" text-align: center; display: flex;align-items: center;justify-content: center;" >
                         <p>{{item.categoryName}}</p>
                       </div>
                     </div>
                   </el-col>
                   <el-col :span="4">
                     <div class="container">
                       <div
                         class="text-container"
                         style="display: flex; align-items: center;justify-content: right;" >
                       </div>
                     </div>
                   </el-col>
                 </el-row>
               </div>
            </div>
            <div v-else>
              <el-empty :image-size="200"></el-empty>    
            </div>
          </div>
        </div>
      </div>
    </div>
    <my-footer></my-footer>
  </div>
</template>

<script>
import myFooter from "../../components/footer.vue";
import {
  getRead,
  getReadingType,
  getBook,
  getSections,
  getReadArticle,
  readingRanking,
  SelfRanking,
  GradeRanking,
} from "@/api/read/index";
import screenfull from "screenfull";
export default {
  components: {
    myFooter,
  },
  data() {
    return {
      myRank: 1,
      typeOf: 0,
      stateOf: 0,
      type: null,
      userInfor: "",
      activeName: 0,
      bookId: "",
      bookName: "",
      img: [
        { icon: "el-icon-s-operation", name: "阅读分类" },
        { icon: "el-icon-timer", name: "阅读排行" },
        { icon: "el-icon-reading", name: "已读文章" },
      ],
      classification: [],
      classIndex: 0,
      lsitData: [
        { value: 1, name: "小学", img: require("../../assets/read/1x.png") },
        { value: 2, name: "中学", img: require("../../assets/read/2x.png") },
        { value: 3, name: "成人", img: require("../../assets/read/3x.png") },
      ],
      tielec: "切换至年级排行",
      male: [
        {
          img: require("../../assets/sculpture/girl1.png"),
          selected: false,
          sex: 1,
        },
        {
          img: require("../../assets/sculpture/girl2.png"),
          selected: false,
          sex: 1,
        },
        {
          img: require("../../assets/sculpture/girl3.png"),
          selected: false,
          sex: 1,
        },
        {
          img: require("../../assets/sculpture/girl4.png"),
          selected: false,
          sex: 1,
        },
        {
          img: require("../../assets/sculpture/girl5.png"),
          selected: false,
          sex: 1,
        },
        {
          img: require("../../assets/sculpture/girl6.png"),
          selected: false,
          sex: 1,
        },
        {
          img: require("../../assets/sculpture/boy1.png"),
          selected: false,
          sex: 0,
        },
        {
          img: require("../../assets/sculpture/boy2.png"),
          selected: false,
          sex: 0,
        },
        {
          img: require("../../assets/sculpture/boy3.png"),
          selected: false,
          sex: 0,
        },
        {
          img: require("../../assets/sculpture/boy4.png"),
          selected: false,
          sex: 0,
        },
        {
          img: require("../../assets/sculpture/boy5.png"),
          selected: false,
          sex: 0,
        },
        {
          img: require("../../assets/sculpture/boy6.png"),
          selected: false,
          sex: 0,
        },
      ],
      ownData: "", //自己的排行数据
      people: [],
      article: [],
      chapter: [],
      ChapterDisplay: true,
      Hidesead: [], //已读数据存放
      isShow: true,
    };
  },
  created() {
    let infor = JSON.parse(sessionStorage.getItem("userInfo"));
    if (infor !== null) {
      this.userInfor = infor;
    }
    screenfull.exit(); // 退出全屏
    this.echurn();
    // this.queryRead()
    // this.readingCharts()
    this.youreaking();
  },
  methods: {
    echurn() {
      let user = this.userInfor;
      getRead(user.memberId).then((res) => {
        if (res.data.ageGroupName == "小学组") {
          this.classIndex = 0;
        }
        if (res.data.ageGroupName == "中学组") {
          this.classIndex = 1;
        }
        if (res.data.ageGroupName == "成人组") {
          this.classIndex = 2;
        }
        getReadingType(user.memberId).then((res) => {
          this.classification = res.data;
          this.books(this.classification[this.typeOf].articleCategoryId);
          if (!screenfull.enabled) {
            return false;
          }
        });
      });
    },
    switchStyle(index) {
      this.activeName = index;
      if (index == 0) this.echurn();
      if (index == 1) this.readingCharts();
      if (index == 2) this.queryRead();
    },
    books(oryId) {
      let user = this.userInfor;
      getBook(oryId).then((res) => {
        this.article = res.data;
        if (this.$route.query.flag == 1 && localStorage.getItem("yuedu")) {
          this.ChapterDisplay = false;
          let a = JSON.parse(localStorage.getItem("yuedu"));
          this.clickToSwitch(a, a.index);
          localStorage.setItem("yuedu", "");
        }
      });
    },
    // 查询已读文章
    queryRead() {
      let test = this.userInfor;
      getReadArticle(test.memberId).then((res) => {
        this.Hidesead = res.data;
      });
    },
    switchButton(event, item) {
      this.typeOf = event;
      this.books(item.articleCategoryId);
    },
    clickToSwitch(event, index) {
      event.index = index;
      localStorage.setItem("yuedu", JSON.stringify(event));
      // console.log(JSON.parse(localStorage.getItem("yuedu")),55555);
      this.bookName = event.bookName;
      this.stateOf = index;
      this.bookId = event.bookId;
      let userData = this.userInfor;
      let obj = {
        memberId: userData.memberId,
        bookId: event.bookId,
      };
      getSections(obj).then((respser) => {
        this.chapter = respser.data;
        this.ChapterDisplay = false;
      });
    },
    Backrent() {
      this.ChapterDisplay = true;
      this.type = null;
    },
    clickEvent(even, index) {
      let mous = JSON.parse(sessionStorage.getItem("autonomous"));
      if (mous.readStatus === 0) {
        this.$message({
          message: "没有阅读权限",
          type: "warning",
          showClose: true,
        });
        return;
      }
      if (even.state === "true") {
        this.$message(even.chapterName + "已完成阅读");
        return;
      }
      if (even.state === "false") {
        this.type = index;
      }
    },
    readChapter(even) {
      this.isShow = false;
      this.$router.push({
        path: "/yuedudati",
        query: {
          chapterId: even.chapterId,
          bookId: this.bookId,
        },
      });
    },
    preparation(val) {},
    // 获取排行榜
    readingCharts() {
      let id = this.userInfor;
      readingRanking(id.memberId).then((res) => {
        this.people = res.data;
        // 自己排行名次
        this.people.forEach((item, index) => {
          if (item.memberName == this.ownData.memberName)
            this.myRank = index + 1;
        });
      });
    },
    youreaking() {
      let user = this.userInfor;
      SelfRanking(user.memberId).then((res) => {
        this.ownData = res.data[0];
      });
    },
    //  年级排行
    geartek(val) {
      let user = this.userInfor;
      if (val == "切换至年级排行") {
        GradeRanking(user.memberId).then((res) => {
          this.tielec = "切换至班级排行";
          this.people = res.data;
          // 自己排行名次
          this.people.forEach((item, index) => {
            if (item.memberName == this.ownData.memberName)
              this.myRank = index + 1;
          });
        });
      }
      if (val == "切换至班级排行") {
        this.tielec = "切换至年级排行";
        this.readingCharts();
      }
    },

    playMusic() {
      this.$router.push({ path: "/music" });
    },
    handleClick(tab, event) {},
  },
};
</script>

<style lang="scss" scoped>
p {
  padding: 0 !important;
}
.cenToct {
  width: 1200px;
  height: 45px;
  padding: 30px 0 0 0;
  line-height: 45px;
  margin: 0 auto;
}
.bg-image {
  width: 100%;
  height: 46vh;
  position: relative;
  .bgImg {
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% 100%; /* 通过百分比设置 */
    background-size: cover; /* 覆盖:图片成比例填满盒子。可用于适配 */
    background-size: contain; /* 包含:图片成比例放大,可能不会填满盒子。可用于适配  */
  }
}
.ciscset {
  width: 100%;
  height: 12vh;
  position: absolute;
  left: 50%;
  bottom: 8%;
  transform: translateX(-50%);
  .between {
    display: flex; /* 使用 flexbox 布局 */
    justify-content: center; /* 左右两端对齐 */
    align-items: center; /* 垂直居中对齐 */
    .itemActive {
      //flex: 1; /* 分配相同的宽度 */
      width: 20%;
      height: 12vh; /* 设定高度 */
      color: #1966ff;
      box-sizing: border-box; /* 盒模型设置为 border-box */
      margin: 0 10px;
      border: 1px solid #ffffff;
      border-radius: 10px;
      background: #ffffff;
      opacity: 0.8;
      border-bottom: 5px solid #2d85ff;
      //background: linear-gradient(to bottom, rgba(184,221,250, 0.8), rgba(231,244,253, 0.8));
    }
    .item {
      //flex: 1; /* 分配相同的宽度 */
      width: 20%;
      height: 12vh; /* 设定高度 */
      box-sizing: border-box; /* 盒模型设置为 border-box */
      margin: 0 10px;
      border: 1px solid #ffffff;
      border-radius: 10px;
      background: #ffffff;
      opacity: 0.8;
      //background: linear-gradient(to bottom, rgba(184,221,250, 0.8), rgba(231,244,253, 0.8));
    }
    .container {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 12vh;
      border-radius: 10px;

      img {
        margin-left: 10%;
      }
    }

    .image-wrap {
      //margin:0 40px 0 30px;
    }

    .image-wrap .Imaset {
      display: block;
      width: 80px;
      height: 90px;
    }

    .info-wrap {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-left: 20px;
      .name {
        font-size: 25px;
        margin: 10px 0 10px 0;
      }
      .gender {
        width: 30px;
        height: 4px;
        border-radius: 10px;
        background: #acd3fe;
        margin-bottom: 10px;
      }
    }
  }
}
.flex-container {
  display: flex;
  width: 100%;
  overflow-x: auto; /* 横向滚动条 */
  .left {
    flex: 0 0 auto;
    width: 280px; /* 固定宽度，可根据需求调整 */
    background: #f7f8fa;
  }
  .right {
    width: 100%; /* 外部容器宽度自适应 */
    height: 660px;
    overflow-y: scroll;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    overflow-x: hidden; /* 横向溢出隐藏 */
    white-space: nowrap; /* 不换行 */
    padding: 20px;
  }
  .right::-webkit-scrollbar {
    display: none;
  }
}
.ulr {
  width: 280px;
  height: 700px;
  margin-top: 10px;
}
.purple-active {
  width: 100%;
  height: 70px;
  color: #098cff;
  line-height: 70px;
  text-align: center;
  font-size: 17px;
  background: #cfe8fe;
}

.bg-purple {
  width: 100%;
  height: 70px;
  color: #565656;
  line-height: 70px;
  text-align: center;
  font-size: 17px;
}

.bg-purple:hover {
  color: #2e81f4;
}

.butRig {
  width: 120px;
  height: 35px;
  border: none;
  color: #fbfbfb;
  border-radius: 30px;
  font-size: 17px;
  background: #396fe4;
}
.el-divider--vertical {
  background: 0 0;
  padding: 2px 0;
}
.el-icon-arrow-left {
  cursor: pointer;
}
.guide {
  width: 1200px;
  height: 180px;
  margin: 40px auto 0;
}
.guideImage {
  width: 100%;
  height: 140px;
  img {
    width: 100%;
    height: 140px;
  }
}

.pagination {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  background: #ffffff;
  box-shadow: 0px -5px 7px -5px rgba(0, 0, 0, 0.3);
}
.hitting {
  padding-top: 20px;
}
.top-seir {
  display: flex; /* 使用flex布局 */
  flex-wrap: wrap;
  width: 100%; /* 设置宽度 */
  .containerImage {
    width: 130px;
    height: 130px;
    background: #f3f8ff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    margin: 0 10px 10px 0;
    scroll-snap-align: start; /* box向左对齐 */
    img {
      width: 50px;
      height: 50px;
    }
  }
  .boxvice {
    box-sizing: border-box;
    border: 2px solid #4dabff;
    width: 130px;
    height: 130px;
    background: #f3f8ff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 20px;
    margin: 0 10px 10px 0;
    scroll-snap-align: start; /* box向左对齐 */
    img {
      width: 50px;
      height: 50px;
    }
  }
}
::v-deep .el-tabs__content {
  height: 100%;
}
.bg-pur-light {
  height: 70px;
  line-height: 70px;
  img {
    vertical-align: middle;
  }
}
.proup1 {
  text-align: right;
  cursor: pointer;
}

.target {
  width: 100%;
  background: #f5f9ff;
  padding-bottom: 30px;
  .popup {
    width: 1200px;
    height: inherit;
    margin: 0 auto;
  }
}
tr > th {
  color: #b5b8bd;
  height: 40px;
  font-size: 13px;
}
tr > td {
  height: 60px;
  line-height: 60px;
}
tr > td > img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  vertical-align: middle;
}
tr:nth-child(even) {
  background-color: #ffffff;
}
tr:nth-child(odd) {
  background-color: #f5f9ff;
}
.offown {
  height: 500px;
  margin-top: 30px;
  margin-bottom: 30px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.offown::-webkit-scrollbar {
  display: none;
}
.conert {
  box-sizing: border-box;
  padding: 2px;
  background: #ffffff;
  border-bottom: 1px solid #e7e7e7;
}
.conertcive {
  box-sizing: border-box;
  padding: 2px;
  background: #ffffff;
  border-bottom: 1px solid #e7e7e7;
  background: #f5f9ff;
}
.nav-top {
  //min-width: 100%;
  height: 60px;
  color: #000000;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.9);
  line-height: 60px;
  box-sizing: border-box;
  padding-left: 20px;
}
.container {
  width: 100%;
  height: 100px;
  display: flex;
  align-items: center;
  img {
    width: 80px;
    height: 90px;
    border-radius: 10px;
    margin-left: 10px;
  }
}

.text-container {
  width: 250px;
  margin-left: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.confirmButton {
  width: 150px;
  height: 35px;
  border: none;
  margin: 20px auto 0;
  border-radius: 30px;
  color: #ffffff;
  font-size: 18px;
  background: linear-gradient(to right, #2d85ff, #2da5ff, #2dbeff);
}
.blue {
  color: #2da5ff;
  font-size: 18px;
}
.lisrCare {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #707070;
  line-height: 60px;
  padding-left: 10px;
  position: relative;
  display: flex;
  align-items: center;
  .blue {
    font-weight: bold;
    color: #509fff;
  }
  .stateTyoe {
    position: absolute;
    top: 5px;
    right: 105px;
  }
  .read {
    position: absolute;
    right: 80px;
  }
}
.lisrCareActive {
  width: 100%;
  height: 60px;
  border-bottom: 1px solid #707070;
  line-height: 60px;
  padding-left: 10px;
  position: relative;
}
</style>